import React from 'react';
import ClientSlider from 'components/LandingPageCarousels/ClientSlider';
import LandingPageLayout from 'components/LandingPageLayout';
import ReservationForm from 'components/LandingPageReservationForm';
import WhyUs from 'components/LandingPageWhyUs';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import TitleSectionOne from 'components/LandingPageTitleSection/TitleSectionOne';
import AllInclucive from 'components/LandingPageAllInclucive';
import ImageBox from 'components/LandingPageImageBox';
import WhatsAppAboutus from 'components/LandingPageAboutUs/WhatsAppAboutus';
import AboutUs from 'components/LandingPageAboutUs';
import Head from 'next/head';

const AllInclusiveStays = () => {
  const clientsData = [
    {
      id: 1,
      image: 'pivot.png',
      name: 'client-1',
    },
    {
      id: 2,
      image: 'rental.png',
      name: 'client2',
    },
    {
      id: 3,
      image: 'globe.png',
      name: 'client-3',
    },
    {
      id: 4,
      image: 'nationalposts.png',
      name: 'client-4',
    },
    {
      id: 5,
      image: 'toronto.png',
      name: 'client-5',
    },
    {
      id: 6,
      image: 'rental.png',
      name: 'client-6',
    },
  ];
  return (
    <>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Stays that are hassle-free.</title>
        <meta
          name="description"
          content="Choose to rent hassle-free using soulrooms. Booking, screening, and communication all at one place, designed for digital native renters like yourself. No paperwork!"
        />
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/all-inclusive-stays" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Stays that are hassle-free." />
        <meta
          property="og:description"
          content="Choose to rent hassle-free using soulrooms. Booking, screening, and communication all at one place, designed for digital native renters like yourself. No paperwork!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="Choose to rent hassle-free using soulrooms. Booking, screening, and communication all at one place, designed for digital native renters like yourself. No paperwork!"
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />

        <link rel="canonical" href="https://www.soulrooms.com/all-inclusive-stays" />
      </Head>
      <LandingPageLayout>
        <AllInclucive
          spacing={true}
          img={
            <iframe
              width="100%"
              height="417"
              src="https://www.youtube.com/embed/co7TdRsbIn0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen></iframe>
          }
          title={'LIVE HASSLE FREE IN TORONTO'}
          description={
            <p
              className="leading-[33px] text-[22px] font-semibold lg:pt-4 md:pt-3 pt-4     "
              style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              Find and book rooms and entire apartments/condos/ houses for rent. Whether you’re moving with friends or
              flying solo, we’ve got you covered.
            </p>
          }
          btn={true}
          btnTitle="See available accommodation options"
          href="#JotFormIFrame-91797058303261"
        />

        <ImageBox noBg={true} />
        {/* CLIENT SLIDER  */}
        <HeadingSection title="AS FEATURED IN:" bgcolor="white" />
        <ClientSlider classN="clients-brand-carousel" clientsData={clientsData} icons={true} />
        {/*  WHY CHOOSE SOULROOMS SECTION  */}
        <WhyUs
          spacing={true}
          bg="none"
          title="HOW IT WORKS"
          heading1="Discover Properties"
          detail1="Find properties and rooms that suit your style and budget."
          heading2="Review Listings"
          detail2="Check out photos, plans, and virtual tours to decide on your perfect rental. "
          heading3="Book & Move"
          detail3="Our online booking and integrated approvals make it easy for landlords and tenants to close the deal."
          img1="/static/images/landingPages/HomePage/howitworks1.png"
          img2="/static/images/landingPages/HomePage/howitworks2.png"
          img3="/static/images/landingPages/HomePage/howitworks3.png"
        />

        {/* RESERVATION FORM  */}
        <ReservationForm heading="FILL IN YOUR REQUIREMENTS & SEE AVAILABLE OPTIONS">
          <iframe
            id="JotFormIFrame-91797058303261"
            title="Find a SoulRoom"
            onLoad={() => {
              window.parent.scrollTo(0, 0);
            }}
            allowTransparency="true"
            allowFullScreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/91797058303261"
            frameBorder="0"
            style={{ minWidth: '100%', height: '640px', border: 'none' }}
            scrolling="no"></iframe>
        </ReservationForm>

        {/* ABOUT US  */}
        {/* <WhatsAppAboutus /> */}
        <AboutUs blackBackground  />

        {/* TITLE SECTION  */}
        <TitleSectionOne
          title="HAVE QUESTIONS?"
          btnTxt="Chat with us"
          bg={'white'}
          hrefExt="https://www.messenger.com/login.php?next=https%3A%2F%2Fwww.messenger.com%2Ft%2F404951336769102%2F%3Fmessaging_source%3Dsource%253Apages%253Amessage_shortlink"
        />
      </LandingPageLayout>
    </>
  );
};

export default AllInclusiveStays;
